// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".l95mGs6\\+{align-items:center;display:flex;justify-content:space-between}.l95mGs6\\+>*+*{margin-left:max(1.5rem,min(3.33vw,4rem))}@media(max-width:667.98px){.l95mGs6\\+{align-items:flex-start;flex-direction:column}.l95mGs6\\+>*+*{margin-left:0;margin-top:max(1.5rem,min(3.33vw,4rem))}}.NFvxiZNT>*+*{margin-top:max(1rem,min(1.15vw,1.38rem))}.Vp9ZmyYn{color:var(--color-gray-4);font-size:max(1rem,min(1.04vw,1.25rem));font-weight:500;line-height:1.4;max-width:50ch}.ohHFFX1F{height:auto;-o-object-fit:contain;object-fit:contain;width:max(8rem,min(29.11vw,34.94rem))}@media(max-width:667.98px){.ohHFFX1F{align-self:flex-end;max-width:18.75rem;width:70%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xs": "667.98",
	"sm": "947.98",
	"md": "1023.98",
	"lg": "1229.98",
	"xl": "1920.98",
	"container": "l95mGs6+",
	"start": "NFvxiZNT",
	"text": "Vp9ZmyYn",
	"img": "ohHFFX1F"
};
module.exports = ___CSS_LOADER_EXPORT___;
